export const ALERT_ACTIONS = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  // Add more actions as needed
};